import { Box, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

export const IntroRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: theme.spacing(5),
  width: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  borderRadius: 4,
  border: `1px solid ${theme.palette.divider}`,
  borderTop: `4px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: theme.spacing(2),
    borderRadius: 0,
  },
  '@media (max-width: 425px)': {
    alignItems: 'center',
  },
}));

export const IntroIllustration = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 160,
  aspectRatio: '140 / 139',
  '& img': {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    width: 120,
  },
}));

export const IntroCopy = styled(Stack)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  '@media (max-width: 425px)': {
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const IntroTitle = styled(Text)({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '32px',
  margin: 0,
});

export const IntroBody = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.secondary,
  margin: 0,
}));
